export const menuLinks = {
  dashboard: "/dashboard",
  raportiControllo: "/document",
  fgas: "/fgasdocuments",
  distinte: "/distinte",
  anomalies: "/anomalies",
  divisions: "/divisions",
  suppliers: "/suppliers",
  users: "/users",
  attachments: "/attachments"
};

export const requiredMessages = {
  requiredField: "Campo è obbligatorio"
};

export const notifyMessages = {
  requiredField: "Campo è obbligatorio",
  errorAccured: "Si è verificato un errore. Riprova!",
  success: "Azione completata con successo",
  addSuccess: "Inserimento effettuato con successo",
  updateFailed: "Aggiornamento non riuscito",
  addFailed: "Inserimento non riuscito",
  retrieveFailed: "Impossibile caricare i dati. Riprova",
  operationSuccess: "Operazione effettuata con successo",
  confirmationMessage: "Vuoi procedere?",
  generateDocumentPdfLoading: "Visualizzazione del documento è in caricamento",
  generateDocumentPdfDownload: "Download del documento in elaborazione",
  noFileFound: "Nessun file trovato"
};

export const formItemLayout = { labelCol: { span: 24 }, wrapperCol: { span: 24 } };

export const drawerWidth = 550;

export const dateFormat = 'DD/MM/YYYY';
export const dateFormatIso = 'YYYY-MM-DD';

export const tablePageSize = 100;

export const roleCode = {
  superAdmin: 1,
  admin: 2,
  operator: 3,
  archivio: 4,
  utenteCna: 5
}

export const documentCategoryCodes = {
  raportiControllo: 1,
  fgas: 2,
  distinte: 3
}


